import { Outlet, Navigate, useLocation } from "react-router-dom";
import { UserRole, useAuth } from "../../context/AuthContext";
import LockedPage from "../Locked";

interface ProtectedashboardRoutesProps {
  allowedRoles?: UserRole[];
}

const ProtectedDashboardRoutes = ({ allowedRoles }: ProtectedashboardRoutesProps) => {
  let context = useAuth();

  const location = useLocation();
  if (context?.currentUser && context.isMFAUser) {
    if (!allowedRoles || (context.userRoles && context.userRoles.some(item => allowedRoles.includes(item)))) {
      return <Outlet context={context} />;
    } else {
      return <Navigate to="pagenotfound" />;
    }
  } else {
    return <Navigate to="pagenotfound" />;
  }
};

export default ProtectedDashboardRoutes;
